module.exports = __webpack_public_path__ + "img/bus-red.156ebbb2.svg";